import { useAtomValue } from 'jotai';
import { useMatch } from 'react-router-dom';
import { unwrappedSelectedPlayerNameAtom } from '@/atoms/player/info';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';

export const useEntityName = () => {
  const isTeamDataLocker = !!useMatch('/:locale/data-locker/teams/*');
  const selectedEntityNameAtom = isTeamDataLocker ? unwrappedSelectedTeamNameAtom : unwrappedSelectedPlayerNameAtom;
  return useAtomValue(selectedEntityNameAtom);
};
